(function () {
  if (window.__ND_UNIT_DIM_UI__) return;
  window.__ND_UNIT_DIM_UI__ = true;

  function normalizeText(s) {
    return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findOptionBlockByTitle(titleRegex) {
    const blocks = Array.from(document.querySelectorAll('[id^="po_stack"]'));
    return blocks.find(block => titleRegex.test(normalizeText(block.textContent || ''))) || null;
  }

  function findDoorSizeWrap() {
    return findOptionBlockByTitle(/\bdoor size\b/i);
  }

  function findSwingWrap() {
    return findOptionBlockByTitle(/\bswing\b/i);
  }

  function findPanelTypeWrap() {
    return findOptionBlockByTitle(/\bpanel type\b/i);
  }

  function ensureUnitDimElements() {
    let wrap = document.getElementById('nd-unit-dim-wrap');
    let row = document.getElementById('nd-unit-dim-row');

    const doorSizeWrap = findDoorSizeWrap();
    if (!doorSizeWrap) return { wrap: null, row: null };

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'nd-unit-dim-wrap';
      wrap.className = 'po-stack po-col-span-12 po-stack-vertical';
      wrap.style.display = 'block';
      wrap.style.width = '100%';
      wrap.style.maxWidth = '100%';
      wrap.style.flex = '0 0 100%';
      wrap.style.boxSizing = 'border-box';
      wrap.style.margin = '0';
      wrap.style.pointerEvents = 'none';

      row = document.createElement('div');
      row.id = 'nd-unit-dim-row';
      row.style.display = 'none';
      row.style.width = '100%';
      row.style.maxWidth = '100%';
      row.style.boxSizing = 'border-box';
      row.style.whiteSpace = 'normal';
      row.style.margin = '12px 0 16px';
      row.style.padding = '0';
      row.style.fontSize = '16px';
      row.style.lineHeight = '1.6';
      row.innerHTML = `
        <div id="nd-unit-dimension-row" style="display:none;">
          <strong>Unit Dim.:</strong> <span id="nd-unit-dim-value"></span>
        </div>
        <div id="nd-rough-opening-row" style="display:none;">
          <strong>Rough Opening:</strong> <span id="nd-rough-opening-value"></span>
        </div>
        <div id="nd-glass-dimension-row" style="display:none;">
          <strong>Glass Dimension:</strong> <span id="nd-glass-dimension-value"></span>
        </div>
      `;

      wrap.appendChild(row);
      doorSizeWrap.insertAdjacentElement('afterend', wrap);
    }

    return { wrap, row };
  }

  function getCheckedLabelTextFromBlock(block) {
    if (!block) return '';

    const checked = block.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) return '';

    const label = checked.closest('label') || checked.parentElement;
    return String(label?.textContent || checked.value || '').trim();
  }

  function getSelectedSizeCode() {
    const txt = getCheckedLabelTextFromBlock(findDoorSizeWrap());
    const m = txt.match(/\b\d{4,6}\b/);
    return m ? m[0] : '';
  }

  function getSelectedSwing() {
    const swingBlock = findSwingWrap();
    if (!swingBlock) return 'all';

    const checked = swingBlock.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) return 'all';

    const label = checked.closest('label') || checked.parentElement;
    const txt = String(label?.textContent || checked.value || '').toLowerCase().trim();

    if (txt.includes('outswing') || txt.includes('out swing')) return 'outswing';
    if (txt.includes('inswing') || txt.includes('in swing')) return 'inswing';

    return 'all';
  }

  function normalizePanelTypeValue(raw) {
    const s = String(raw || '').toLowerCase().trim();

    if (/3\/4\s*lite|three\s*quarter\s*lite|three_quarter_lite/.test(s)) {
      return 'three_quarter_lite';
    }
    if (/full\s*view|full\s*lite|full_lite/.test(s)) {
      return 'full_lite';
    }
    return '';
  }

  function initSelectedPanelType() {
    const panelBlock = findPanelTypeWrap();
    if (!panelBlock) return;

    const checked = panelBlock.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) return;

    const panelType = normalizePanelTypeValue(checked.value || checked.textContent || '');
    if (panelType) {
      window.__ND_SELECTED_PANEL_TYPE__ = panelType;
    }
  }

  function getSelectedPanelType() {
    if (window.__ND_SELECTED_PANEL_TYPE__) {
      return window.__ND_SELECTED_PANEL_TYPE__;
    }

    const panelBlock = findPanelTypeWrap();
    if (!panelBlock) return '';

    const checked = panelBlock.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) return '';

    return normalizePanelTypeValue(checked.value || checked.textContent || '');
  }

  function getProductContext() {
    const title = normalizeText(document.querySelector('h1')?.textContent || '');
    const path = normalizeText(location.pathname || '');
    const text = `${title} ${path}`;

    if (text.includes('single hinged door')) {
      return { doorType: 'hinged', doorStyle: 'single_hinged' };
    }

    if (text.includes('double hinged door')) {
      return { doorType: 'hinged', doorStyle: 'double_hinged' };
    }

    if (text.includes('center hinged door') && text.includes('2 panels')) {
      return { doorType: 'hinged', doorStyle: 'center_hinged_2_panel' };
    }

    if (text.includes('center hinged door') && text.includes('3 panels')) {
      return { doorType: 'hinged', doorStyle: 'center_hinged_3_panel' };
    }

    if (text.includes('vented sidelight')) {
      return { doorType: 'hinged', doorStyle: 'vented_sidelight' };
    }

    if (text.includes('bypass gliding door')) {
      return { doorType: 'gliding', doorStyle: 'bypass_gliding' };
    }

    if (text.includes('gliding door') && text.includes('2 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_2_panel' };
    }

    if (text.includes('gliding door') && text.includes('3 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_3_panel' };
    }

    if (text.includes('gliding door') && text.includes('4 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_4_panel' };
    }

    if (text.includes('fixed (gliding) - 1 panel')) {
      return { doorType: 'fixed', doorStyle: 'gliding_one_panel' };
    }

    if (text.includes('fixed - 1 panel')) {
      return { doorType: 'fixed', doorStyle: 'hinged_one_panel' };
    }

    if (text.includes('fixed - 2 panels')) {
      return { doorType: 'fixed', doorStyle: 'hinged_two_panel' };
    }

    if (text.includes('fixed - 3 panels')) {
      return { doorType: 'fixed', doorStyle: 'hinged_three_panel' };
    }

    if (text.includes('transom - 1 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_1_lite' };
    }

    if (text.includes('transom - 2 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_2_lite' };
    }

    if (text.includes('transom - 3 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_3_lite' };
    }

    if (text.includes('transom - 4 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_4_lite' };
    }

    return { doorType: '', doorStyle: '' };
  }

  function getDoorType() {
    return getProductContext().doorType;
  }

  function getDoorStyle() {
    return getProductContext().doorStyle;
  }

  function syncUnitDim() {
    const { row } = ensureUnitDimElements();
    if (!row) return;

    const sizeCode = getSelectedSizeCode();
    const swing = getSelectedSwing();
    const panelType = getSelectedPanelType();
    const doorType = getDoorType();
    const doorStyle = getDoorStyle();

    const data = window.getUnitDimensionData
      ? window.getUnitDimensionData(doorType, doorStyle, sizeCode, panelType, swing)
      : { unit_dimension: '', rough_opening: '', glass_dimension: '' };

    const unitDim = data.unit_dimension || '';
    const roughOpening = data.rough_opening || '';
    const glassDimension = data.glass_dimension || '';

    const unitRow = document.getElementById('nd-unit-dimension-row');
    const unitValueEl = document.getElementById('nd-unit-dim-value');
    if (unitValueEl) unitValueEl.textContent = unitDim;
    if (unitRow) unitRow.style.display = unitDim ? 'block' : 'none';

    const roughRow = document.getElementById('nd-rough-opening-row');
    const roughValueEl = document.getElementById('nd-rough-opening-value');
    if (roughValueEl) roughValueEl.textContent = roughOpening;
    if (roughRow) roughRow.style.display = roughOpening ? 'block' : 'none';

    const glassRow = document.getElementById('nd-glass-dimension-row');
    const glassValueEl = document.getElementById('nd-glass-dimension-value');
    if (glassValueEl) glassValueEl.textContent = glassDimension;
    if (glassRow) glassRow.style.display = glassDimension ? 'block' : 'none';

    row.style.display = (unitDim || roughOpening || glassDimension) ? 'block' : 'none';

    console.log('[UnitDim]', {
      doorType,
      doorStyle,
      sizeCode,
      panelType,
      swing,
      unitDim,
      roughOpening,
      glassDimension
    });
  }

  function bindEventsOnce() {
    if (window.__ND_UNIT_DIM_BOUND__) return;
    window.__ND_UNIT_DIM_BOUND__ = true;

    document.addEventListener('change', function (e) {
      const target = e.target;
      if (!target) return;

      const block = target.closest('[id^="po_stack"]');
      if (block && /Panel Type/i.test(block.textContent || '')) {
        const panelType = normalizePanelTypeValue(target.value || target.textContent || '');
        if (panelType) {
          window.__ND_SELECTED_PANEL_TYPE__ = panelType;
        }
      }

      setTimeout(syncUnitDim, 80);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSelectedPanelType();
    ensureUnitDimElements();
    bindEventsOnce();
    setTimeout(syncUnitDim, 200);
  });

  setTimeout(function () {
    initSelectedPanelType();
    ensureUnitDimElements();
    bindEventsOnce();
    syncUnitDim();
  }, 800);

  window.syncUnitDim = syncUnitDim;
})();